import { PipelineApplication } from '../../../entities/applicant_tracking/PipelineApplication';
import {
  Application,
  ApplicationStatus,
  BriefApplication,
} from '../../../entities/Application';
import { JobHiringMemberRole } from '../../../entities/JobHiringMemberRole';
import { User } from '../../../entities/User';
import {
  ApplicationActionInfo,
  getApplicationActionInfo,
} from './applicationActions';

export function buildScheduleInterviewPagePath(
  applicationId: number | string,
  interviewStageId?: number | string,
  selfSchedule?: boolean,
  returnTitle?: string,
) {
  const schedulingType = selfSchedule
    ? 'interview_candidate_users/new'
    : 'interviews/schedule';

  const schedulePath =
    `/applicant_tracking/applications/${applicationId}/${schedulingType}?` +
    `interview_stage_id=${interviewStageId}`;

  return addReturnTitle(schedulePath, returnTitle);
}
export function addReturnTitle(path: string, value?: string) {
  const search = new URLSearchParams(window.location.search);
  const returnTitle = value || search?.get('return_title');
  if (returnTitle) {
    path += `&return_title=${returnTitle}`;
  }

  return path;
}

export function buildSchedulingActionInfo(
  application: Application | BriefApplication | PipelineApplication,
  currentUser: User,
  jobHiringMemberRole: JobHiringMemberRole,
): ApplicationActionInfo {
  const baseApplicationInfo = getApplicationActionInfo(
    application,
    currentUser.isAdmin,
    jobHiringMemberRole,
    'Schedule an Interview',
  );
  const allowedJobStatuses = ['open', 'published'];

  if (!baseApplicationInfo.allowed || baseApplicationInfo.disabled) {
    return baseApplicationInfo;
  } else if (!allowedJobStatuses.includes(application.job.status)) {
    return {
      allowed: true,
      disabled: true,
      tooltipText: `Scheduling is not available for applications in ${application.job.status} jobs`,
    };
  } else if (!application.nextInterviewStageId) {
    return {
      allowed: true,
      disabled: true,
      tooltipText: 'Scheduling is only available for stages with interviews.',
    };
  } else if (application.status === ApplicationStatus.Rejected) {
    return {
      allowed: true,
      disabled: true,
      tooltipText: 'Scheduling is not available for rejected applications.',
    };
  } else {
    return {
      allowed: true,
      disabled: false,
      tooltipText: 'Schedule an Interview',
    };
  }
}
